// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const PINPOINT_KEY_PREFIX = 'Pinpoint';
export const STORAGE_KEY_SUFFIX = '_inAppMessages';
export const CATEGORY = 'InAppMessaging';
export const CHANNEL_TYPE = 'IN_APP';
